module.exports = __webpack_public_path__ + "OpenSans-Regular.d7d5d4588a9f50c99264.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/assets/fonts/open-sans/OpenSans-Regular.ttf
// module id = ../../../../../src/assets/fonts/open-sans/OpenSans-Regular.ttf
// module chunks = styles